export const SUPPORTS_OBJECT_DEFINE_PROPERTY = "defineProperty" in Object;
